exports = module.exports = require("../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "gz-time-picker .time-picker{position:relative;min-height:44px}gz-time-picker .time-picker .small-label{position:absolute;top:-6px;font-size:12px;color:rgba(0,0,0,.54)}gz-time-picker .time-picker .small-label.required:after{content:\" *\"}gz-time-picker .time-inputs{margin-bottom:2px;border-bottom:1px solid rgba(0,0,0,.12);padding-bottom:1px}gz-time-picker .time-inputs md-input-container{padding:0}gz-time-picker .time-inputs input{border:none;height:24px}gz-time-picker .time-inputs .separator{margin-bottom:2px}gz-time-picker .time-inputs .separator:after{content:\":\"}gz-time-picker md-input-container{margin:0}gz-time-picker md-input-container .md-errors-spacer{display:none}gz-time-picker md-input-container input{max-width:32px;text-align:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/sass-loader!../~/@printos/gazelle/src/components/time-picker/time-picker.scss
// module id = 120
// module chunks = 0